export enum PolicyType {
  TECHNICAL = 'Technical',
  NON_TECHNICAL = 'Non-Technical',
  CONTROL = 'Control',
  AUTH_POLICY = 'AuthPolicy'
}
